(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-linked-options"] && !Shopify.designMode) return;
  try {
    function setupCompactProductGallery(root) {
  root.querySelectorAll('.mc-product-layout .gallery-control').forEach(function (gallery) {
    if (gallery.dataset.mcCompactGallery === 'true') return;

    var sourceRow = gallery.querySelector('.relative.main_img > .row');
    if (!sourceRow) return;

    function galleryLabel(alt, src, index) {
      var text = (String(alt || '') + ' ' + String(src || '')).toLowerCase().replace(/[-_]+/g, ' ');
      if (text.indexOf('living room') !== -1) return 'Living room';
      if (text.indexOf('bedroom') !== -1) return 'Bedroom';
      if (text.indexOf('hallway console') !== -1 || text.indexOf('hallway and console') !== -1) return 'Hallway';
      if (text.indexOf('artwork detail') !== -1) return 'Artwork detail';
      return index === 0 ? 'Room view' : index === 1 ? 'Artwork' : index === 2 ? 'Canvas detail' : 'Finish detail';
    }

    var allSourceItems = Array.from(sourceRow.children).map(function (item, index) {
      var link = item.querySelector('a[href]');
      var image = item.querySelector('img');
      if (!link || !image) return null;
      var alt = image.alt || 'Product image';
      var src = image.currentSrc || image.getAttribute('src') || image.dataset.src || link.href;
      return {
        src: src,
        href: link.href,
        alt: alt,
        label: galleryLabel(alt, src, index)
      };
    }).filter(Boolean);

    var preferredTerms = ['living room', 'bedroom', 'hallway console', 'artwork detail'];
    var preferredItems = preferredTerms.map(function (term) {
      return allSourceItems.find(function (item) {
        var text = (item.alt + ' ' + item.src).toLowerCase().replace(/[-_]+/g, ' ');
        return text.indexOf(term) !== -1 && text.indexOf('gallery 60x38') !== -1;
      }) || allSourceItems.find(function (item) {
        return (item.alt + ' ' + item.src).toLowerCase().replace(/[-_]+/g, ' ').indexOf(term) !== -1;
      });
    }).filter(Boolean);
    var sourceItems = preferredItems.concat(allSourceItems.filter(function (item) {
      return preferredItems.indexOf(item) === -1;
    })).slice(0, 4);
    if (!sourceItems.length) return;

    gallery.dataset.mcCompactGallery = 'true';
    sourceRow.hidden = true;
    sourceRow.setAttribute('aria-hidden', 'true');

    var shell = document.createElement('div');
    var stage = document.createElement('div');
    var mainLink = document.createElement('a');
    var mainImage = document.createElement('img');
    var previous = document.createElement('button');
    var next = document.createElement('button');
    var counter = document.createElement('span');
    var thumbs = document.createElement('div');
    var shots = [];
    var activeIndex = 0;

    shell.className = 'mc-gallery-shell';
    stage.className = 'mc-gallery-stage';
    mainLink.setAttribute('data-fancybox', 'mc-product-gallery');
    mainImage.loading = 'eager';
    mainImage.fetchPriority = 'high';
    previous.type = 'button';
    previous.className = 'mc-gallery-nav mc-gallery-prev';
    previous.setAttribute('aria-label', 'Previous product image');
    previous.textContent = '‹';
    next.type = 'button';
    next.className = 'mc-gallery-nav mc-gallery-next';
    next.setAttribute('aria-label', 'Next product image');
    next.textContent = '›';
    counter.className = 'mc-gallery-counter';
    counter.setAttribute('aria-live', 'polite');
    thumbs.className = 'mc-gallery-thumbs';
    thumbs.setAttribute('aria-label', 'Product images');
    mainLink.appendChild(mainImage);
    stage.appendChild(mainLink);
    stage.appendChild(previous);
    stage.appendChild(next);
    stage.appendChild(counter);
    shell.appendChild(stage);
    shell.appendChild(thumbs);
    sourceRow.parentNode.insertBefore(shell, sourceRow);

    var aftercare = document.createElement('section');
    aftercare.className = 'mc-gallery-aftercare';
    aftercare.innerHTML = '<h3>Made with care in Birmingham</h3><div class="mc-gallery-aftercare-grid"><div class="mc-gallery-aftercare-item"><strong>Ready to display</strong><span>Canvas options arrive fitted with hanging hardware.</span></div><div class="mc-gallery-aftercare-item"><strong>Tracked delivery</strong><span>Follow your order from our workshop to your door.</span></div><div class="mc-gallery-aftercare-item"><strong>30-day returns</strong><span>Shop with a clear and straightforward returns window.</span></div><div class="mc-gallery-aftercare-item"><strong>Secure checkout</strong><span>Available payment methods are confirmed at checkout.</span></div></div>';
    shell.appendChild(aftercare);

    function currentVariantShot() {
      var variantImage = document.querySelector('.engoj_img_main');
      var src = variantImage && (variantImage.currentSrc || variantImage.getAttribute('src'));
      if (!src) return sourceItems[0];
      return {
        src: src,
        href: src,
        alt: variantImage.alt || 'Selected product preview',
        label: 'Your selection'
      };
    }

    function buildShots() {
      var selected = currentVariantShot();
      shots = [selected].concat(sourceItems.filter(function (item) {
        return item.src.split('?')[0] !== selected.src.split('?')[0];
      }));
    }

    function renderThumbs() {
      thumbs.innerHTML = '';
      shots.forEach(function (shot, index) {
        var button = document.createElement('button');
        var image = document.createElement('img');
        var label = document.createElement('span');
        button.type = 'button';
        button.className = 'mc-gallery-thumb';
        button.setAttribute('aria-label', 'Show ' + shot.label);
        button.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
        image.src = shot.src;
        image.alt = '';
        image.loading = index < 2 ? 'eager' : 'lazy';
        label.className = 'mc-gallery-thumb-label';
        label.textContent = shot.label;
        button.appendChild(image);
        button.appendChild(label);
        button.addEventListener('click', function () { render(index); });
        thumbs.appendChild(button);
      });
    }

    function render(index) {
      if (!shots.length) return;
      activeIndex = (index + shots.length) % shots.length;
      mainImage.src = shots[activeIndex].src;
      mainImage.alt = shots[activeIndex].alt;
      mainLink.href = shots[activeIndex].href;
      counter.textContent = (activeIndex + 1) + ' / ' + shots.length;
      thumbs.querySelectorAll('.mc-gallery-thumb').forEach(function (button, buttonIndex) {
        button.setAttribute('aria-pressed', buttonIndex === activeIndex ? 'true' : 'false');
      });
    }

    function refreshVariantShot() {
      var selected = currentVariantShot();
      if (shots[0] && shots[0].src === selected.src) return;
      buildShots();
      activeIndex = 0;
      renderThumbs();
      render(0);
    }

    previous.addEventListener('click', function () { render(activeIndex - 1); });
    next.addEventListener('click', function () { render(activeIndex + 1); });
    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') render(activeIndex - 1);
      if (event.key === 'ArrowRight') render(activeIndex + 1);
    });

    buildShots();
    renderThumbs();
    render(0);

    var variantImage = document.querySelector('.engoj_img_main');
    if (variantImage) {
      new MutationObserver(refreshVariantShot).observe(variantImage, { attributes: true, attributeFilter: ['src'] });
    }

    var form = document.querySelector('#AddToCartForm');
    if (form) {
      form.addEventListener('change', function () {
        setTimeout(refreshVariantShot, 120);
        setTimeout(refreshVariantShot, 420);
      });
    }
  });
}

function setupLinkedProductOptions(root) {
  root.querySelectorAll('#AddToCartForm').forEach(function (form) {
    if (form.dataset.mcLinkedOptions === 'true') return;

    var swatches = Array.from(form.querySelectorAll('.swatch'));
    var formatSwatch = swatches.find(function (swatch) {
      var title = swatch.querySelector('.title_variant');
      return title && title.textContent.trim().toLowerCase() === 'format';
    });
    var sizeSwatch = swatches.find(function (swatch) {
      var title = swatch.querySelector('.title_variant');
      return title && title.textContent.trim().toLowerCase() === 'size';
    });
    var frameSwatch = swatches.find(function (swatch) {
      var title = swatch.querySelector('.title_variant');
      return title && title.textContent.trim().toLowerCase() === 'frame';
    });

    if (!formatSwatch || !sizeSwatch) return;
    form.dataset.mcLinkedOptions = 'true';

    var detailInfo = form.closest('.detail-info');
    var productRow = detailInfo && detailInfo.closest('.row');
    if (detailInfo) detailInfo.classList.add('mc-product-master');
    if (productRow) productRow.classList.add('mc-product-layout');
    form.classList.add('mc-product-config');

    function enhanceSwatch(swatch, modifier) {
      if (!swatch || swatch.dataset.mcEnhanced === 'true') return;
      swatch.dataset.mcEnhanced = 'true';
      swatch.classList.add(modifier);

      var title = swatch.querySelector('.title_variant');
      var options = Array.from(swatch.children).filter(function (child) {
        return child.hasAttribute('data-value');
      });
      var head = document.createElement('div');
      var current = document.createElement('span');
      var grid = document.createElement('div');
      head.className = 'mc-option-head';
      current.className = 'mc-current-choice';
      current.setAttribute('aria-live', 'polite');
      grid.className = 'mc-option-grid';
      if (title) head.appendChild(title);
      head.appendChild(current);
      swatch.insertBefore(head, swatch.firstChild);
      options.forEach(function (option) { grid.appendChild(option); });
      swatch.appendChild(grid);

      function updateCurrent() {
        var checked = swatch.querySelector('input[type="radio"]:checked');
        current.textContent = checked ? checked.value : '';
      }
      swatch.addEventListener('change', updateCurrent);
      updateCurrent();
    }

    enhanceSwatch(formatSwatch, 'mc-format-swatch');
    enhanceSwatch(sizeSwatch, 'mc-size-swatch');
    enhanceSwatch(frameSwatch, 'mc-frame-swatch');

    var labels = root.querySelector('.mc-linked-options') || document.querySelector('.mc-linked-options');
    var sizeLabels = {
      'a5': { cm: 'A5 · 14.8 × 21 cm', inch: 'A5 · 5.8 × 8.3 in' },
      'a4': { cm: 'A4 · 21 × 29.7 cm', inch: 'A4 · 8.3 × 11.7 in' },
      'a3': { cm: 'A3 · 29.7 × 42 cm', inch: 'A3 · 11.7 × 16.5 in' },
      'a2': { cm: 'A2 · 42 × 59.4 cm', inch: 'A2 · 16.5 × 23.4 in' },
      'a1': { cm: 'A1 · 59.4 × 84.1 cm', inch: 'A1 · 23.4 × 33.1 in' },
      '12 x 8': { cm: '30 × 20 cm', inch: '12 × 8 in' },
      '18 x 12': { cm: '46 × 30 cm', inch: '18 × 12 in' },
      '24 x 16': { cm: '61 × 41 cm', inch: '24 × 16 in' },
      '30 x 20': { cm: '76 × 51 cm', inch: '30 × 20 in' },
      '36 x 24': { cm: '91 × 61 cm', inch: '36 × 24 in' },
      '48 x 32': { cm: '122 × 81 cm', inch: '48 × 32 in' },
      '60 x 38': { cm: '152 × 97 cm', inch: '60 × 38 in' },
      '54 x 36': { cm: '137 × 91 cm', inch: '54 × 36 in' },
      '72 x 48': { cm: '183 × 122 cm', inch: '72 × 48 in' },
      '90 x 60': { cm: '229 × 152 cm', inch: '90 × 60 in' }
    };

    function setUnit(unit) {
      sizeSwatch.querySelectorAll('[data-value]').forEach(function (item) {
        var value = (item.dataset.value || '').trim().toLowerCase();
        var text = sizeLabels[value];
        var optionLabel = item.querySelector('label');
        if (text && optionLabel) optionLabel.textContent = text[unit];
      });

      sizeSwatch.querySelectorAll('.mc-unit-toggle button').forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.unit === unit ? 'true' : 'false');
      });
    }

    function addUnitToggle() {
      if (sizeSwatch.querySelector('.mc-unit-toggle')) return;

      var toggle = document.createElement('div');
      toggle.className = 'mc-unit-toggle';
      toggle.setAttribute('role', 'group');
      toggle.setAttribute('aria-label', labels ? labels.dataset.unitLabel : 'Measurement units');

      ['cm', 'inch'].forEach(function (unit) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.unit = unit;
        button.textContent = labels ? labels.dataset[unit + 'Label'] : unit.toUpperCase();
        button.addEventListener('click', function () {
          setUnit(unit);
        });
        toggle.appendChild(button);
      });

      var optionHead = sizeSwatch.querySelector('.mc-option-head');
      if (optionHead) optionHead.appendChild(toggle);
      else sizeSwatch.insertBefore(toggle, sizeSwatch.firstChild);
      setUnit('cm');
    }

    function polishProductDetails() {
      if (!detailInfo) return;
      var comparePrice = detailInfo.querySelector('.enj-product-price-compare');
      if (comparePrice && /^\s*£?0(?:\.00)?(?:\s*GBP)?\s*$/i.test(comparePrice.textContent)) {
        comparePrice.classList.add('mc-hide-compare');
      }
    }

    function addPurchaseSummary() {
      if (!detailInfo || form.querySelector('.mc-purchase-summary')) return;
      var priceWrap = detailInfo.querySelector('.product-price');
      var livePrice = detailInfo.querySelector('.engoj_price_main');
      var firstSwatch = form.querySelector('.swatch');
      if (!priceWrap || !livePrice || !firstSwatch) return;

      var summary = document.createElement('section');
      var heading = document.createElement('div');
      var priceColumn = document.createElement('div');
      var label = document.createElement('span');
      var checkoutNote = document.createElement('p');
      summary.className = 'mc-purchase-summary';
      heading.className = 'mc-purchase-summary-head';
      priceColumn.className = 'mc-purchase-price';
      label.className = 'mc-purchase-label';
      label.textContent = 'Your selected price';
      checkoutNote.className = 'mc-checkout-note';
      checkoutNote.textContent = 'Taxes, delivery and available payment methods are confirmed securely at checkout.';
      priceColumn.appendChild(label);
      priceColumn.appendChild(priceWrap);
      heading.appendChild(priceColumn);
      summary.appendChild(heading);
      summary.appendChild(checkoutNote);
      firstSwatch.parentNode.insertBefore(summary, firstSwatch);
    }

    function addStickyCart() {
      if (!detailInfo || document.querySelector('.mc-sticky-cart')) return;
      var originalButton = form.querySelector('.shop-button.enj-add-to-cart-btn');
      var livePrice = detailInfo.querySelector('.engoj_price_main');
      if (!originalButton || !livePrice) return;

      var bar = document.createElement('div');
      var price = document.createElement('span');
      var button = document.createElement('button');
      bar.className = 'mc-sticky-cart';
      price.className = 'mc-sticky-price';
      button.className = 'mc-sticky-button';
      button.type = 'button';
      button.textContent = originalButton.textContent.trim();
      price.textContent = livePrice.textContent.trim();
      bar.appendChild(price);
      bar.appendChild(button);
      detailInfo.appendChild(bar);

      button.addEventListener('click', function () { originalButton.click(); });
      new MutationObserver(function () {
        price.textContent = livePrice.textContent.trim();
        button.disabled = originalButton.disabled;
      }).observe(livePrice, { childList: true, characterData: true, subtree: true });
    }

    function selectFrameValue(value) {
      if (!frameSwatch) return;
      var match = Array.from(frameSwatch.querySelectorAll('[data-value]')).find(function (item) {
        return (item.dataset.value || '').trim().toLowerCase() === value;
      });
      var input = match && match.querySelector('input[type="radio"]');
      if (input && !input.checked) input.click();
    }

    function updateLinkedSizes() {
      var selectedFormat = formatSwatch.querySelector('input[type="radio"]:checked');
      if (!selectedFormat) return;

      var selectedFormatValue = selectedFormat.value.trim().toLowerCase();
      var showPrintSizes = selectedFormatValue === 'print only';
      var showTriptychSizes = selectedFormatValue.indexOf('triptych') !== -1 || selectedFormatValue.indexOf('3 panels') !== -1;
      var triptychSizes = ['36 x 24', '54 x 36', '72 x 48', '90 x 60'];
      var canvasSizes = ['12 x 8', '18 x 12', '24 x 16', '30 x 20', '36 x 24', '48 x 32', '60 x 38'];
      var firstVisibleInput = null;
      var selectedSizeIsVisible = false;

      sizeSwatch.querySelectorAll('[data-value]').forEach(function (item) {
        var value = (item.dataset.value || '').trim();
        var isPrintSize = /^a[1-5]$/i.test(value);
        var shouldShow = false;
        if (showPrintSizes) shouldShow = isPrintSize;
        else if (showTriptychSizes) shouldShow = triptychSizes.indexOf(value) !== -1;
        else shouldShow = canvasSizes.indexOf(value) !== -1;
        var input = item.querySelector('input[type="radio"]');

        item.hidden = !shouldShow;
        item.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

        if (shouldShow && input) {
          if (!firstVisibleInput) firstVisibleInput = input;
          if (input.checked) selectedSizeIsVisible = true;
        }
      });

      if (!selectedSizeIsVisible && firstVisibleInput) {
        requestAnimationFrame(function () {
          firstVisibleInput.click();
        });
      }

      if (frameSwatch) {
        frameSwatch.hidden = !showPrintSizes;
        frameSwatch.setAttribute('aria-hidden', showPrintSizes ? 'false' : 'true');

        frameSwatch.querySelectorAll('[data-value]').forEach(function (item) {
          var value = (item.dataset.value || '').trim().toLowerCase();
          var shouldShow = showPrintSizes ? true : value === 'unframed';
          item.hidden = !shouldShow;
          item.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        });

        if (showPrintSizes) {
          var selectedFrame = frameSwatch.querySelector('input[type="radio"]:checked');
          if (!selectedFrame || selectedFrame.value.trim().toLowerCase() === 'not applicable') {
            requestAnimationFrame(function () {
              selectFrameValue('unframed');
            });
          }
        } else {
          requestAnimationFrame(function () {
            selectFrameValue('unframed');
          });
        }
      }
    }

    function queueLinkedSizeUpdate() {
      requestAnimationFrame(updateLinkedSizes);
      setTimeout(updateLinkedSizes, 100);
    }

    formatSwatch.addEventListener('change', queueLinkedSizeUpdate);
    formatSwatch.addEventListener('click', queueLinkedSizeUpdate);

    addUnitToggle();
    polishProductDetails();
    setTimeout(polishProductDetails, 250);
    setTimeout(polishProductDetails, 750);
    addStickyCart();
    addPurchaseSummary();
    updateLinkedSizes();
    setTimeout(updateLinkedSizes, 250);
    setTimeout(updateLinkedSizes, 750);
  });
}

function setupProductDecisionSupport(root) {
  root.querySelectorAll('#AddToCartForm').forEach(function (form) {
    if (form.dataset.mcDecisionSupport === 'true') return;

    var swatches = Array.from(form.querySelectorAll('.swatch'));
    function findSwatch(name) {
      return swatches.find(function (swatch) {
        var title = swatch.querySelector('.title_variant');
        return title && title.textContent.trim().toLowerCase() === name;
      });
    }
    function addHelp(swatch, text) {
      if (!swatch || swatch.querySelector('.mc-option-help')) return null;
      var help = document.createElement('p');
      var head = swatch.querySelector('.mc-option-head');
      help.className = 'mc-option-help';
      help.textContent = text;
      if (head) head.insertAdjacentElement('afterend', help);
      else {
        var title = swatch.querySelector('.title_variant');
        if (title) title.insertAdjacentElement('afterend', help);
        else swatch.insertBefore(help, swatch.firstChild);
      }
      return help;
    }

    var formatSwatch = findSwatch('format');
    var sizeSwatch = findSwatch('size');
    var frameSwatch = findSwatch('frame');
    var panelsSwatch = findSwatch('no of panels');
    var formatHelp = addHelp(formatSwatch, 'Choose the finish that best suits your room.');

    function updateFormatHelp() {
      if (!formatHelp || !formatSwatch) return;
      var selected = formatSwatch.querySelector('input[type="radio"]:checked');
      var value = selected ? selected.value.trim().toLowerCase() : '';
      if (value === 'print only') {
        formatHelp.textContent = 'Print sizes run from A5 to A1. Choose unframed, or add a Black, White or Gold frame.';
      } else if (value.indexOf('triptych') !== -1 || value.indexOf('3 panels') !== -1) {
        formatHelp.textContent = 'The artwork is split across three deep gallery canvases. The listed size is for the whole set, excluding wall gaps.';
      } else if (value.indexOf('18mm') !== -1) {
        formatHelp.textContent = 'A slim 18mm canvas profile, supplied ready to display.';
      } else if (value.indexOf('38mm') !== -1) {
        formatHelp.textContent = 'A deeper 38mm gallery canvas for a stronger, premium wall presence.';
      } else {
        formatHelp.textContent = 'Choose between a print, slim canvas or deep gallery canvas.';
      }
    }

    addHelp(sizeSwatch, 'Dimensions are the finished artwork size. Measure your wall before ordering.');
    addHelp(frameSwatch, 'Frames apply to Print Only. Canvas options are finished without an additional frame.');
    addHelp(panelsSwatch, 'Single Panel is one continuous piece. 3 Panel divides the design across three pieces; the listed size is the combined artwork size, excluding gaps.');

    function addWallGuide() {
      if (!sizeSwatch || form.querySelector('.mc-wall-guide')) return;
      var widths = {
        'a5': 10, 'a4': 12, 'a3': 16, 'a2': 21, 'a1': 28,
        '12 x 8': 14, '18 x 12': 20, '24 x 16': 26, '30 x 20': 32,
        '36 x 24': 38, '48 x 32': 52, '60 x 38': 64,
        '54 x 36': 57, '72 x 48': 70, '90 x 60': 78
      };
      var guide = document.createElement('details');
      var summary = document.createElement('summary');
      var body = document.createElement('div');
      var scene = document.createElement('div');
      var art = document.createElement('div');
      var sofa = document.createElement('div');
      var copy = document.createElement('p');
      guide.className = 'mc-wall-guide';
      summary.textContent = 'See the selected size on a wall';
      body.className = 'mc-wall-guide-body';
      scene.className = 'mc-wall-scene';
      art.className = 'mc-wall-art';
      sofa.className = 'mc-wall-sofa';
      copy.className = 'mc-wall-guide-copy';
      scene.appendChild(art);
      scene.appendChild(sofa);
      body.appendChild(scene);
      body.appendChild(copy);
      guide.appendChild(summary);
      guide.appendChild(body);
      sizeSwatch.insertAdjacentElement('afterend', guide);

      function updateWallGuide() {
        var selectedSize = sizeSwatch.querySelector('input[type="radio"]:checked');
        var selectedFormat = formatSwatch && formatSwatch.querySelector('input[type="radio"]:checked');
        var value = selectedSize ? selectedSize.value.trim().toLowerCase() : '';
        var format = selectedFormat ? selectedFormat.value.trim().toLowerCase() : '';
        var label = selectedSize && selectedSize.parentElement.querySelector('label');
        var isTriptych = format.indexOf('triptych') !== -1 || format.indexOf('3 panels') !== -1;
        var galleryImages = Array.from(document.querySelectorAll('.mc-gallery-thumb img, .gallery-control img'));
        var sourceImage = galleryImages.find(function (image) {
          return /flat artwork|print only|unframed/i.test(image.alt || '');
        }) || document.querySelector('.engoj_img_main');
        var isPortrait = sourceImage && sourceImage.naturalHeight > sourceImage.naturalWidth;
        art.style.setProperty('--mc-art-width', String(widths[value] || 34) + '%');
        art.style.setProperty('--mc-art-ratio', isPortrait && !isTriptych ? '2/3' : '3/2');
        if (sourceImage && (sourceImage.currentSrc || sourceImage.src)) {
          art.style.setProperty('--mc-art-image', 'url("' + (sourceImage.currentSrc || sourceImage.src).replace(/"/g, '%22') + '")');
        }
        art.classList.toggle('mc-wall-art-triptych', isTriptych);
        if (isTriptych) {
          art.innerHTML = '';
          [0, 1, 2].forEach(function () { art.appendChild(document.createElement('span')); });
          var triptychLabel = document.createElement('em');
          triptychLabel.textContent = label ? label.textContent : selectedSize ? selectedSize.value : 'Selected size';
          art.appendChild(triptychLabel);
        } else {
          art.innerHTML = '';
          var artLabel = document.createElement('em');
          artLabel.textContent = label ? label.textContent : selectedSize ? selectedSize.value : 'Selected size';
          art.appendChild(artLabel);
        }
        copy.textContent = 'Approximate room illustration only. Measure your wall before ordering and allow suitable space around the artwork.';
      }

      form.addEventListener('change', updateWallGuide);
      sizeSwatch.addEventListener('click', function () { setTimeout(updateWallGuide, 0); });
      if (formatSwatch) formatSwatch.addEventListener('click', function () { setTimeout(updateWallGuide, 120); });
      updateWallGuide();
    }

    function addDeliverySummary() {
      if (form.querySelector('.mc-delivery-summary')) return;
      var cartArea = form.querySelector('.btn-action.detail-attr.qty-cart');
      if (!cartArea) return;
      var summary = document.createElement('section');
      summary.className = 'mc-delivery-summary';
      summary.setAttribute('aria-label', 'Delivery and returns');
      summary.innerHTML = '<div><strong>Made to order in Birmingham</strong><span>Carefully prepared and sent with tracking. Delivery timing is confirmed at checkout. <a href="/pages/shipping-policy">Delivery details</a></span></div><div><strong>Buy with confidence</strong><span>Review the returns terms before ordering. <a href="/policies/refund-policy">Returns policy</a></span></div>';
      cartArea.parentNode.insertBefore(summary, cartArea);
    }

    if (formatSwatch) {
      formatSwatch.addEventListener('change', updateFormatHelp);
      updateFormatHelp();
    }
    addWallGuide();
    addDeliverySummary();
    form.dataset.mcDecisionSupport = 'true';
  });
}

function setupProductDescription(root) {
  var description = root.querySelector('#des .product-desc') || document.querySelector('#des .product-desc');
  if (!description || description.classList.contains('mc-product-description')) return;

  var children = Array.from(description.children);
  var headings = children.filter(function (child) { return child.tagName === 'H3'; });
  function headingIndex(text) {
    var heading = headings.find(function (item) {
      return item.textContent.trim().toLowerCase() === text;
    });
    return heading ? children.indexOf(heading) : -1;
  }

  var formatIndex = headingIndex('choose your format');
  var sizesIndex = headingIndex('sizes');
  var readyIndex = headingIndex('ready to hang');
  var madeIndex = headingIndex('made in birmingham');
  var customIndex = headingIndex('custom sizing');
  if ([formatIndex, sizesIndex, readyIndex, madeIndex, customIndex].some(function (index) { return index < 0; })) return;

  function section(className, start, end) {
    var element = document.createElement('section');
    element.className = className;
    children.slice(start, end).forEach(function (child) { element.appendChild(child); });
    return element;
  }

  var intro = section('mc-description-intro', 0, formatIndex);
  var format = section('mc-description-panel mc-format-explainer', formatIndex, sizesIndex);
  var sizes = section('mc-description-panel mc-size-explainer', sizesIndex, readyIndex);
  var ready = section('mc-description-card', readyIndex, madeIndex);
  var made = section('mc-description-card', madeIndex, customIndex);
  var custom = section('mc-description-card', customIndex, children.length);
  var mainGrid = document.createElement('div');
  var cardGrid = document.createElement('div');
  mainGrid.className = 'mc-description-main-grid';
  cardGrid.className = 'mc-description-card-grid';
  mainGrid.appendChild(format);
  mainGrid.appendChild(sizes);
  cardGrid.appendChild(ready);
  cardGrid.appendChild(made);
  cardGrid.appendChild(custom);

  description.classList.add('mc-product-description');
  description.appendChild(intro);
  description.appendChild(mainGrid);
  description.appendChild(cardGrid);
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/search') document.documentElement.classList.add('mc-search-page');
  setupLinkedProductOptions(document);
  setupProductDecisionSupport(document);
  setupCompactProductGallery(document);
  setupProductDescription(document);
});

document.addEventListener('shopify:section:load', function (event) {
  setupLinkedProductOptions(event.target);
  setupProductDecisionSupport(event.target);
  setupCompactProductGallery(event.target);
  setupProductDescription(event.target);
});
  } catch(e) { console.error(e); }
})();

})();
